import React from 'react';

interface LoaderProps {
  text: string;
  subText: string;
}

const Loader: React.FC<LoaderProps> = ({ text, subText }) => (
  <div className="fixed inset-0 bg-surface/60 backdrop-blur-md flex items-center justify-center z-50">
    <div className="text-center p-8 bg-surface rounded-[16px] border border-line shadow-lg max-w-xs w-full mx-4">
      <div className="relative w-12 h-12 mx-auto mb-6">
        <svg className="animate-spin w-full h-full text-accent" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3"></circle>
          <path className="opacity-100" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
      <p className="text-lg font-bold text-fg leading-tight mb-2" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700 }}>
        {text}
      </p>
      <p className="text-sm text-muted leading-relaxed" style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 400 }}>
        {subText}
      </p>
    </div>
  </div>
);

export default Loader;
